import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { shortenandHoverString, getControlStyle } from '../helper';

export default function CalculationComp(props) {
  const { rowIndex, colIndex, relation, gridIndex, pageIndex, otherConfiguration } = props;
  const combinedStyles = getControlStyle(otherConfiguration);

  return (
    <FormGroup className="flex-fill position-relative mb-0" key={`tableSourced_${pageIndex}_${gridIndex}_${rowIndex}_${colIndex}`}>
      <div>
        <div style={combinedStyles} className="align-items-center">
          {shortenandHoverString(relation?.readOnlyFormulaString, 12)}
        </div>
      </div>
    </FormGroup>
  );
}
